import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getMarketSectorSchema = () => {
  return z.object({
    SectorName: z
      .string()
      .min(1, { message: "Sector name is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("marketSectorList.sectorName"), isRequired: true }))
  });
};

const getMarketSectorDefaultValue = (value = null) => {
  return {
    SectorName: value ? value?.SectorName : ""
  };
};

const getMarketSectorAPIPostSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    marketSector: [
      {
        SectorId: "",
        SectorName: null,
        Deleted: false,
        CountryCode: countryCode,
        BusinessCode: businessCode,
      },
    ],
  };
};

const getMarketSectorAuditInfoSchema = () => {
  return {
    auditInfo: [
      {
        Location: "Market Sector",
        LocationKey: "",
        Action: null,
        shortDesc: null,
        currentState: null,
        previousState: null,
      },
    ],
  };
};

export { getMarketSectorSchema, getMarketSectorDefaultValue, getMarketSectorAPIPostSchema, getMarketSectorAuditInfoSchema };
